import Multiselect from 'multiselect-react-dropdown'
import { useLocation } from 'react-router-dom'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import GrileService from '../../services/grile-service.js'
import Grid from '../../components/Grid'
import FileBase64 from 'react-file-base64'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'
import pdfToText from 'react-pdftotext'

import './create.css'
import Spinner from '../../components/Spinner'
import Button from '../../components/Button'
import { useAuthContext } from 'context'
import { getFullDateHourString, orderAnswerOptionsDescending } from 'utils'

import Swal from 'sweetalert2'
import UploadSection from './UploadSection'
import AddPageSection from './AddPageSection'
import { toBase64 } from 'utils'

const GrilaCreator = () => {
  const maxNrChoices = 6

  const [elements, setElements] = useState([{ type: 'text', content: '' }])
  const [remainingElements, setRemainingElements] = useState([])
  const [allSources, setAllSources] = useState([])
  const [allFaculties, setAllFaculties] = useState([])
  const [selectedSource, setSelectedSource] = useState([])
  const [selectedFaculty, setSelectedFaculty] = useState([])
  const [choices, setChoices] = useState([
    { type: 'choice-text-0', content: '' },
    { type: 'choice-text-1', content: '' },
    { type: 'choice-text-2', content: '' },
    { type: 'choice-text-3', content: '' },
    { type: 'choice-text-4', content: '' },
    { type: 'choice-text-5', content: '' },
  ])
  const { userDetails } = useAuthContext()
  const { hash } = useLocation()
  const [allTags, setAllTags] = useState([])
  const [currentSubjectTags, setCurrentSubjectTags] = useState([])
  const [selectSubjectOptions, setSelectSubjectOptions] = useState([])
  const [selectedSubject, setSelectedSubject] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedTagsForGenerate, setSelectedTagsForGenerate] = useState([])
  const [choicesType, setChoicesType] = useState('text')
  const [loadId, setLoadId] = useState('')
  const [deleted, setDeleted] = useState(false)
  const [excludePages, setExcludePages] = useState(
    localStorage.getItem('excludePages') === 'true',
  )
  const [indenting, setIndenting] = useState(false)
  const [generating, setGenerating] = useState(false)
  const [copying, setCopying] = useState(false)
  const [faculty, setFaculty] = useState('')
  const [multipleChoice, setMultipleChoice] = useState(false)
  const [answer, setAnswer] = useState('-1')
  const [explain, setExplain] = useState(undefined)
  const [hint, setHint] = useState(undefined)
  const [replace, setReplace] = useState('')
  const [generateButtonDisabled, setGenerateButtonDisabled] = useState(false)
  const [creatorEmail, setCreatorEmail] = useState('')
  const [updatedTimestamp, setUpdatedTimestamp] = useState('')
  const multiselectRef = useRef()
  const [height, setHeight] = useState(0)
  const [usingMode, setUsingMode] = useState('load') // load || copy || generate
  const [copySource, setCopySource] = useState(undefined)
  const [gridsFromSource, setGridsFromSource] = useState(undefined)
  const [currentIndexGridFromSource, setCurrentIndexGridFromSource] =
    useState(undefined)
  const [currentSubmitedFromSource, setCurrentSubmitedFromSource] = useState([])
  const [indexToStartFromSource, setIndexToStartFromSource] = useState(0)
  const [nrGridsFromSource, setNrGridsFromSource] = useState(-1)
  const [books, setBooks] = useState([])
  const [currentGridBookId, setCurrentGridBookId] = useState(-1)

  const isCopyComponentVisible = useCallback(() => {
    return userDetails?.isAdmin && usingMode === 'copy'
  }, [userDetails, usingMode])

  const isLoadComponentVisible = useCallback(() => {
    return usingMode === 'load'
  }, [usingMode])

  const isGenerateComponentVisible = useCallback(() => {
    return userDetails?.isAdmin && usingMode === 'generate'
  }, [userDetails, usingMode])

  const getBookById = useCallback(() => {
    const book = books?.find(book => book?.id === currentGridBookId)

    return book
      ? {
          book_name: book.name,
          book_page_offset: book.page_offset,
        }
      : undefined
  }, [books, currentGridBookId])

  const handleSetTagsForSubject = useCallback(
    subjectName => {
      const tags = []

      allTags.forEach(tag => {
        // subjectName = materie
        if (tag.materie === subjectName) {
          if (!excludePages || !tag.name.includes('page-')) {
            tags.push(tag)
          }
        }
      })

      setCurrentSubjectTags(tags)
    },
    [allTags, excludePages],
  )

  const handleClear = useCallback(() => {
    setFaculty('')
    setAnswer('-1')
    setExplain(undefined)
    setHint(undefined)
    setReplace('')
    const email = userDetails?.email
    setCreatorEmail(email)
    setUpdatedTimestamp('')

    setChoices([
      { type: 'choice-text-0', content: '' },
      { type: 'choice-text-1', content: '' },
      { type: 'choice-text-2', content: '' },
      { type: 'choice-text-3', content: '' },
      { type: 'choice-text-4', content: '' },
      { type: 'choice-text-5', content: '' },
    ])
    setElements([{ type: 'text', content: '' }])
    setMultipleChoice(false)
    setSelectedTags([])
    setChoicesType('text')
    setLoadId('')
    setDeleted(false)
    multiselectRef.current.resetSelectedValues()
  }, [userDetails])

  const handleAddElement = useCallback(type => {
    setElements(current => [...current, { type, content: '' }])
  }, [])

  useEffect(() => {
    handleSetTagsForSubject(selectedSubject?.[0]?.name)
  }, [excludePages, handleSetTagsForSubject, selectedSubject])

  useEffect(() => {
    const excludePagesStorage = localStorage.getItem('excludePages')

    if (excludePagesStorage !== null) {
      setExcludePages(excludePagesStorage === 'true')
    }
  }, [])

  const selectSource = (source_id, all_sources, all_faculties) => {
    const sourceElement = all_sources.filter(source => source.id === source_id)
    setSelectedSource(sourceElement)
    setSelectedFaculty(
      all_faculties.filter(
        faculty => faculty.id === sourceElement[0].faculty_id,
      ),
    )
  }

  const handleLoadHintAndExplainFromStorage = useCallback(() => {
    const hintStorage = localStorage.getItem('hint-create')
    const explainStorage = localStorage.getItem('explain-create')

    if (hintStorage !== null) {
      setHint(hintStorage)
    }

    if (explainStorage !== null) {
      setExplain(explainStorage)
    }
  }, [hint, explain, generating])

  const handleLoadGrid = useCallback(
    async (grila, generated = false) => {
      if (grila.json === undefined) {
        toast.warn('Nu există nicio grila cu acest id.')
        return
      }

      if (grila.similar_grila !== undefined) {
        toast.warn(
          <div>
            Grila este similară cu grila{' '}
            <a
              href={`/create-grid#${grila.similar_grila}`}
              target="_blank"
              rel="noreferrer"
            >
              grila {grila.similar_grila}
            </a>
            . <br />
            Distanță: {grila.distance}
          </div>,
        )
      }

      const json = JSON.parse(grila.json)
      const elements = []
      const choices = []
      let choicesType = 'text'
      for (const elem of json) {
        if (elem.type && elem.type.includes('choice')) {
          const s = elem.type.split('-')

          choices.push(elem)

          if (choicesType === 'text') {
            choicesType = s[1]
          }
          if (['text', 'code', 'matrix'].indexOf(choicesType) === -1) {
            choicesType = 'text'
          }
        } else {
          elements.push(elem)
        }
      }

      if (grila.explain_answers) {
        const explainAnswers = JSON.parse(grila.explain_answers)
        for (const [choice, explain] of Object.entries(explainAnswers)) {
          const s = choice.split('-')
          const choiceId = parseInt(s[1])

          choices[choiceId]['explainContent'] = explain
        }
      }

      setElements(elements)
      setChoicesType(choicesType)
      setChoices(choices)

      if (!generated) {
        setSelectedTags(allTags.filter(tag => grila.tags?.includes(tag.id)))
        setDeleted(grila.deleted)
      }

      let subject = undefined

      if (grila.materie_copiat !== null) {
        subject = selectSubjectOptions.filter(
          subject => subject.name === grila.materie_copiat,
        )
        setSelectedSubject(subject)
        handleSetTagsForSubject(subject?.[0]?.name)
      }

      setFaculty(grila.faculty ?? '')
      setAnswer(grila.answer ?? '-1')
      setExplain(grila.explain ?? undefined)
      setHint(grila.hint ?? undefined)
      setReplace(grila.id ?? '')
      setMultipleChoice(grila.multiple_choice ?? false)
      setCreatorEmail(grila.creator_email ?? '')
      setUpdatedTimestamp(grila.updated_timestamp ?? '')
      setCurrentGridBookId(grila.book_id ?? -1)

      if (grila.source_id) {
        const sources = await GrileService.getAllSources()
        const faculties = await GrileService.getAllFaculties()
        selectSource(grila.source_id, sources, faculties)
      } else {
        setSelectedSource([])
        setSelectedFaculty([])
      }
    },
    [allTags, selectSubjectOptions, handleSetTagsForSubject],
  )

  useEffect(() => {
    const init = async () => {
      const tags = await GrileService.getAllTags()
      setAllTags(tags)

      const sources = await GrileService.getAllSources()
      setAllSources(sources)

      const faculties = await GrileService.getAllFaculties()
      setAllFaculties(faculties)

      const books = await GrileService.getAllBooks()
      setBooks(books)

      const materii = []

      tags?.forEach(tag => {
        if (materii.indexOf(tag.materie) === -1) {
          materii.push(tag.materie)
        }
      })

      const options = []
      let index = 1
      materii.forEach(materie => {
        options.push({ id: index, name: materie })
        index += 1
      })

      setSelectSubjectOptions(options)
    }

    init()
  }, [])

  useEffect(() => {
    if (hash) {
      const grilaId = parseInt(hash.slice(1))
      setLoadId(grilaId)
      GrileService.grilaWithId(grilaId).then(response =>
        handleLoadGrid(response),
      )
    }
  }, [hash, handleLoadGrid])

  const handleReplaceAt = (str, index, chr) => {
    if (index > str.length - 1) return str
    return str.substring(0, index) + chr + str.substring(index + 1)
  }

  const handleChangeMultipleChoice = e => {
    setMultipleChoice(e.target.checked)
  }

  const getPayloadForSubmit = useCallback(() => {
    const json = []
    const elementsCopy = [...elements]
    const choicesCopy = [...choices]

    for (let index = 0; index < elementsCopy.length; index++) {
      if (elementsCopy[index].content) {
        json.push(elementsCopy[index])
      }
    }

    for (let index = 0; index < choicesCopy.length; index++) {
      if (choicesCopy[index].content.length > 0) {
        json.push(choicesCopy[index])
      }
    }

    let copyAnswer = answer

    for (let i = 0; i < copyAnswer.length; ++i) {
      if (copyAnswer[i] >= 'a' && copyAnswer[i] <= 'z') {
        copyAnswer = handleReplaceAt(
          copyAnswer,
          i,
          copyAnswer.charCodeAt(i) - 'a'.charCodeAt(0),
        )
      } else if (copyAnswer[i] >= 'A' && copyAnswer[i] <= 'Z') {
        copyAnswer = handleReplaceAt(
          copyAnswer,
          i,
          copyAnswer.charCodeAt(i) - 'A'.charCodeAt(0),
        )
      }
    }

    if (copyAnswer.length > 1 && copyAnswer[0] === '0') {
      const t = copyAnswer[0]
      copyAnswer = handleReplaceAt(copyAnswer, 0, copyAnswer[1])
      copyAnswer = handleReplaceAt(copyAnswer, 1, t)
    }

    let tagsText = '{'
    for (const tag of selectedTags) {
      tagsText += tag.id
      tagsText += ','
    }

    if (tagsText.length > 1) {
      tagsText = tagsText.slice(0, -1)
    }

    tagsText += '}'

    return [json, copyAnswer, tagsText]
  }, [elements, choices, answer, selectedTags])

  const handleSubmit = useCallback(
    async (insert_similar = false) => {
      const [json, answerText, tagsText] = getPayloadForSubmit()

      const explainAnswers = {}

      for (let i = 0; i < choices.length; ++i) {
        if (choices[i]['explainContent'] !== undefined) {
          explainAnswers['choice-' + i] = choices[i]['explainContent']
        }
      }

      const payload = {
        json,
        faculty,
        tags: tagsText,
        answer: answerText,
        explain,
        source_id: selectedSource.length > 0 ? selectedSource[0].id : 'null',
        hint,
        deleted,
        materie_copiat:
          selectedSubject && selectedSubject.length > 0
            ? selectedSubject[0].name
            : null,
        multiple_choice: multipleChoice,
        insert_similar: insert_similar === true ? 'true' : undefined,
        explain_answers: explainAnswers,
      }

      if (replace) {
        payload['replace_id'] = replace
      }

      const response = await GrileService.create(payload)
      if (Object.keys(response).includes('error')) {
        toast.warn(response.error)
      } else {
        if (Object.keys(response).includes('similar_grila')) {
          Swal.fire({
            icon: 'info',
            title: 'Grilă asemănătoare găsită!',
            html: `Grila este foarte similară cu <a href='/create-grid#${response.similar_grila}' target='_blank'>grila ${response.similar_grila}</a>. <br>Distanță: ${response.distance}`,
            showDenyButton: true,
            confirmButtonText: 'Creează oricum',
            denyButtonText: `Cancel`,
            theme: 'dark',
          }).then(result => {
            if (result.isConfirmed) {
              handleSubmit(true)
            }
          })
        } else {
          if (replace) {
            toast.warn(`Ai înlocuit grila cu id: ${response.id}`)
          } else {
            toast.warn(`Ai creat grila cu id: ${response.id}`)
          }
          handleClear()
          setSelectedTags([])
          multiselectRef.current.resetSelectedValues()
        }
      }

      window.scrollTo(0, 0)
    },
    [
      deleted,
      handleClear,
      explain,
      choices,
      faculty,
      getPayloadForSubmit,
      hint,
      multipleChoice,
      replace,
      selectedSource,
      selectedSubject,
    ],
  )

  const insertSpaceAfterSymbols = inputText => {
    let text = inputText
    const spaceAround = ['>', '<', '=', '≤']
    const spaceAfter = [',', ';', '.']
    let newText = ''

    text = text.replaceAll('<br>', 'BR_EXCEPTION')
    text = text.replaceAll('<b>', 'B_EXCEPTION')

    for (let index = 0; index < text.length; index++) {
      if (
        spaceAround.includes(text[index]) ||
        spaceAfter.includes(text[index])
      ) {
        // insert space before symbol if there is not already a symbol, a space, or we are not in the '0.5' case
        if (
          spaceAround.includes(text[index]) &&
          index > 0 &&
          text[index - 1] !== ' ' &&
          !spaceAround.includes(text[index - 1]) &&
          (text[index - 1] < '0' || text[index - 1] > '9')
        ) {
          newText += ' '
        }

        newText += text[index]
        // same, but after
        if (
          index + 1 < text.length &&
          text[index + 1] !== ' ' &&
          !(
            spaceAround.includes(text[index + 1]) ||
            spaceAfter.includes(text[index + 1])
          ) &&
          (text[index] !== '.' ||
            text[index + 1] < '0' ||
            text[index + 1] > '9')
        ) {
          newText += ' '
        }
      } else {
        newText += text[index]
      }
    }
    newText = newText.replaceAll('BR_EXCEPTION', '<br>')
    newText = newText.replaceAll('B_EXCEPTION', '<b>')

    return newText
  }

  const handleLoadNext = useCallback(async () => {
    GrileService.nextGrila(loadId).then(grila => {
      if (grila.json === undefined) {
        toast.warn('Nu există grile cu id mai mare.')
      } else {
        setLoadId(grila.id)
        handleLoadGrid(grila)
      }
    })
  }, [loadId, handleLoadGrid])

  const handleLoadPrev = useCallback(async () => {
    GrileService.prevGrila(loadId).then(grila => {
      if (grila.json === undefined) {
        toast.warn('No există grile cu id mai mic.')
      } else {
        setLoadId(grila.id)
        handleLoadGrid(grila)
      }
    })
  }, [loadId, handleLoadGrid])

  const handleFormat = (element, removeNewLines = true) => {
    let ret = undefined

    if (element) {
      if (element.content) {
        ret = element.content
      } else {
        ret = element
      }

      if (removeNewLines) {
        ret = ret.replaceAll(/\s+/g, ' ')
      } else {
        ret = ret.replaceAll('\n ', '\n')
      }
      ret = ret.trim()
      return ret
        .replaceAll('”', '"')
        .replaceAll('”', '"')
        .replaceAll('’', "'")
        .replaceAll('’', "'")
        .replaceAll('”', '"')
        .replaceAll('”', '"')
    }

    return undefined
  }

  const handleIndentChoiceCode = useCallback(
    async index => {
      setIndenting(true)
      const code = handleFormat(choices[index].content)

      GrileService.indent({ code })
        .then(result => {
          if (Object.keys(result).includes('error')) {
            toast.warn(result.error)
          } else {
            const copyChoices = [...choices]
            copyChoices[index] = {
              type: `choice-code-${index}`,
              content: result.code,
            }
            setChoices(copyChoices)
          }
          setIndenting(false)
        })
        .catch(() => {
          setIndenting(false)
          toast.warn('Indentarea răspunsurilor a eșuat!')
        })
      setIndenting(false)
    },
    [choices],
  )

  const handlePaste = (e, index) => {
    setTimeout(() => {
      const copyElements = [...elements]
      copyElements[index] = {
        type: 'text',
        content: handleFormat(e.target.value),
      }
      setElements(copyElements)
    }, 0)
  }

  const handleIndentCode = useCallback(
    async index => {
      setIndenting(true)
      if (elements && elements[index] && elements[index].content) {
        const code = handleFormat(elements[index].content)

        GrileService.indent({ code })
          .then(result => {
            if (Object.keys(result).includes('error')) {
              toast.warn(result.error)
            } else {
              const copyElements = [...elements]
              copyElements[index] = { type: `code`, content: result.code }
              setElements(copyElements)
            }
            setIndenting(false)
          })
          .catch(() => {
            setIndenting(false)
            toast.warn('Indentarea a eșuat!')
          })
      }
      setIndenting(false)
    },
    [elements],
  )

  const handleCodePaste = index => {
    setTimeout(() => {
      handleIndentCode(index)
    }, 0)
  }

  const handleChoicePaste = useCallback(
    (e, index) => {
      const separators = [')', '.']
      const letters = ['a', 'b', 'c', 'd', 'e', 'f']
      setTimeout(() => {
        const content = handleFormat(e.target.value, choicesType !== 'matrix')
        let multipleChoicesPaste = false

        const lowerCaseContent = content?.toLowerCase()
        if (choices.length === 1 && index === 0) {
          // special paste functionality
          const newChoices = []

          for (const separator of separators) {
            if (
              lowerCaseContent[0].toLowerCase() === 'a' &&
              lowerCaseContent[1].toLowerCase() === separator &&
              lowerCaseContent.includes(`b${separator}`) &&
              lowerCaseContent.includes(`c${separator}`)
            ) {
              multipleChoicesPaste = true
              let choiceBeginIndex = 2
              let choiceEndIndex

              for (let i = 0; i < letters.length; ++i) {
                if (
                  i < letters.length - 1 &&
                  lowerCaseContent.indexOf(letters[i + 1] + separator) !== -1
                ) {
                  choiceEndIndex = lowerCaseContent.indexOf(
                    letters[i + 1] + separator,
                  )
                } else {
                  choiceEndIndex = lowerCaseContent.length
                }

                const newChoiceContent = handleFormat(
                  content.slice(choiceBeginIndex, choiceEndIndex),
                  choicesType !== 'matrix',
                )
                if (newChoiceContent) {
                  newChoices.push({
                    type: `choice-${choicesType}-${newChoices.length}`,
                    content: newChoiceContent,
                  })
                }

                if (choicesType === 'code') {
                  handleIndentChoiceCode(index)
                }

                choiceBeginIndex = choiceEndIndex + 2
              }
              break
            }
          }
          if (multipleChoicesPaste) {
            setChoices(newChoices)
          }
        }

        if (!multipleChoicesPaste) {
          if (choicesType === 'code') {
            handleIndentChoiceCode(index)
          } else {
            const copyChoices = [...choices]
            if (index < copyChoices.length) {
              copyChoices[index].content = content
              setChoices(copyChoices)
            }
          }
        }
      }, 0)
    },
    [choicesType, choices, handleIndentChoiceCode],
  )

  const indentPseudocode = useCallback(inputText => {
    const increaseTabsTokens = ['for', 'algorithm', 'if', 'else', 'while']
    const decreaseTabsTokens = [
      'endfor',
      'endalgorithm',
      'endif',
      'endelse',
      'else',
      'endwhile',
    ]

    let text = inputText
    text = text.replaceAll(':', ':\n')
    text = text.replaceAll(' If', '\nIf')
    text = text.replaceAll('EndIf', '\nEndIf\n')
    text = text.replaceAll('EndFor', '\nEndFor\n')
    text = text.replaceAll(' For', '\nFor')
    text = text.replaceAll('execute', 'execute\n')
    text = text.replaceAll('then', 'then\n')
    text = text.replaceAll('EndAlgorithm', '\nEndAlgorithm')
    text = text.replaceAll('Write', '\nWrite')
    text = text.replaceAll('\n\n', '\n')
    text = text.replaceAll(
      /([a-zA-Z][a-zA-Z_0-9]*)(\[[a-zA-Z]\s[-+*/%]\s*[a-zA-Z_0-9]*\])* ←/g,
      '\n$1$2 ←',
    )
    const elements = text.split('\n')
    let tabs = 0

    let newText = ''

    for (let index = 0; index < elements.length; index++) {
      const element = elements[index]

      const lineBeginning = element.trimStart().split(' ')[0]

      if (decreaseTabsTokens.indexOf(lineBeginning.toLowerCase()) !== -1) {
        if (tabs > 0) {
          tabs -= 1
        }
      }

      let nextDontIndent = false
      const tabsArray = new Array(tabs).fill('  ')

      if (element.trimStart().length > 0) {
        if (!nextDontIndent) {
          newText += tabsArray.join('')
        }

        newText += element.trimStart()

        if (lineBeginning !== 'For') {
          newText += '\n'
          nextDontIndent = false
        } else {
          newText += elements[index + 1].trimStart()
          newText += '\n'
          index += 1
        }
      }

      if (increaseTabsTokens.indexOf(lineBeginning.toLowerCase()) !== -1) {
        tabs += 1
      }
    }

    return newText
  }, [])

  const handleIndentChoicePseudocode = useCallback(
    async index => {
      setIndenting(true)
      if (choices && choices[index] && choices[index].content) {
        const newText = indentPseudocode(choices[index].content)

        const copyChoices = [...choices]
        copyChoices[index].content = newText
        setChoices(copyChoices)
      }

      setIndenting(false)
    },
    [choices, indentPseudocode],
  )

  const handleIndentPseudocode = useCallback(
    async index => {
      setIndenting(true)
      if (elements && elements[index] && elements[index].content) {
        const newText = indentPseudocode(elements[index].content)

        const copyElements = [...elements]
        copyElements[index].content = newText
        setElements(copyElements)
      }
      setIndenting(false)
    },
    [elements, indentPseudocode],
  )

  const handleGenerateGrila = useCallback(async () => {
    const selectedTagsName = []
    selectedTagsForGenerate.forEach(tag => {
      selectedTagsName.push(tag.name)
    })

    setGenerating(true)
    setGenerateButtonDisabled(true)
    setTimeout(() => setGenerateButtonDisabled(false), 5000)

    handleClear()

    const payload = { filters: selectedTagsName }

    let response = undefined
    try {
      response = await GrileService.generateGrila(payload)
    } catch (error) {
      toast.warn(error)
    }

    setGenerating(false)
    const content = response?.choices?.[0].message?.content
    const escapedContent = content?.replace('\n', '')
    const parsedJson = JSON.parse(escapedContent)
    const grila = { id: undefined, json: parsedJson['questions'] }

    const localElements = []
    const localRemainingElements = []
    const choicesContent = []
    let choicesType = 'text'

    if (grila && grila.json) {
      for (const elem of grila.json) {
        if (elem.type) {
          if (elem.type.includes('choice')) {
            const s = elem.type.split('-')
            choicesContent.push(elem)

            choicesType = s[1]
            if (['text', 'code', 'matrix'].indexOf(choicesType) === -1) {
              choicesType = 'text'
            }
          } else {
            localElements.push(elem)
          }
        }
        localRemainingElements.push(elem)
      }
    }

    setElements(localElements)
    const localRemainingElementsString = JSON.stringify(localRemainingElements)

    setRemainingElements(localRemainingElementsString)
    setChoicesType(choicesType)
    setChoices(choicesContent)
  }, [selectedTagsForGenerate, handleClear])

  const handleRegenerateGrila = useCallback(async () => {
    handleClear()

    const localElements = []
    const choicesContent = []
    let choicesType = 'text'
    const jsonElements = JSON.parse(remainingElements)

    for (const elem of jsonElements) {
      if (elem.type) {
        if (elem.type.includes('choice')) {
          const s = elem.type.split('-')
          choicesContent.push(elem)

          choicesType = s[1]
          if (['text', 'code', 'matrix'].indexOf(choicesType) === -1) {
            choicesType = 'text'
          }
        } else {
          localElements.push(elem)
        }
      }
    }

    setElements(localElements)
    setChoicesType(choicesType)
    setChoices(choicesContent)
  }, [handleClear, remainingElements])

  const handleAnswerChange = useCallback(async e => {
    setAnswer(e.target.value)
  }, [])

  const handleHintChange = useCallback(
    async e => {
      setHint(e.target.value)

      if (e.target.value !== undefined) {
        localStorage.setItem('hint-create', e.target.value)
      }
    },
    [hint],
  )

  const handleExplainChange = useCallback(
    async e => {
      setExplain(e.target.value)

      if (e.target.value !== undefined) {
        localStorage.setItem('explain-create', e.target.value)
      }
    },
    [explain],
  )

  const handleChangeBoxType = useCallback(
    async (e, type, index) => {
      const copyElements = [...elements]

      if (index < copyElements.length && copyElements[index].type !== type) {
        copyElements[index].type = type
        setElements(copyElements)
      }
    },
    [elements],
  )

  const handleChangeChoicesType = useCallback(
    async (e, type) => {
      setChoicesType(type)

      const copyChoices = [...choices]
      for (let index = 0; index < copyChoices.length; index++) {
        copyChoices[index].type = `choice-${type}-${index}`
      }

      setChoices(copyChoices)
    },
    [choices],
  )

  const handleChangeChoices = useCallback(
    async (e, index) => {
      if (choices.length > index) {
        const copyChoices = [...choices]
        const newElem = {
          type: copyChoices[index].type,
          content: e.target.value,
          explainContent: copyChoices[index].explainContent,
        }

        copyChoices[index] = newElem
        setChoices(copyChoices)
      }
    },
    [choices],
  )

  const handleAddChoiceExplain = useCallback(
    async index => {
      if (choices.length > index) {
        const copyChoices = [...choices]
        const newElem = {
          ...choices[index],
          explainContent: '',
        }

        copyChoices[index] = newElem
        setChoices(copyChoices)
      }
    },
    [choices],
  )

  const handleRemoveChoiceExplain = useCallback(
    async index => {
      if (choices.length > index) {
        const copyChoices = [...choices]
        const newElem = {
          ...choices[index],
          explainContent: undefined,
        }

        copyChoices[index] = newElem
        setChoices(copyChoices)
      }
    },
    [choices],
  )

  const handleSetChoiceExplain = useCallback(
    async (e, index) => {
      if (choices.length > index) {
        const copyChoices = [...choices]
        const newElem = {
          ...choices[index],
          explainContent: e.target.value,
        }

        copyChoices[index] = newElem
        setChoices(copyChoices)
      }
    },
    [choices],
  )

  const explainAnswersPreview = useMemo(() => {
    const ret = {}

    for (let i = 0; i < choices.length; ++i) {
      if (choices[i]['explainContent'] !== undefined) {
        ret['choice-' + i] = choices[i]['explainContent']
      }
    }
    return ret
  }, [choices])

  const handleChangeTextarea = useCallback(
    async (e, index) => {
      if (elements.length > index) {
        const newElem = { type: elements[index].type, content: e.target.value }
        const copyElements = [...elements]

        copyElements[index] = newElem
        setElements(copyElements)
      }
    },
    [elements],
  )

  const handleAddChoice = useCallback(async () => {
    if (choices.length < maxNrChoices) {
      const choicesCopy = [...choices]
      choicesCopy.push({
        type: `choice-${choicesType}-${choices.length}`,
        content: '',
      })
      setChoices(choicesCopy)
    }
  }, [choices, choicesType])

  const handleLoadImage = useCallback(
    async (e, index) => {
      const copyElements = [...elements]
      if (index < copyElements.length) {
        copyElements[index].content = e.base64
        setElements(copyElements)
      }
    },
    [elements],
  )

  const handlePasteImage = async (e, index) => {
    if (e.clipboardData.files.length) {
      const fileObject = e.clipboardData.files[0]
      const base64 = await toBase64(fileObject)

      const copyElements = [...elements]
      copyElements[index].content = base64
      setElements(copyElements)
    } else {
      toast.warn('Nu ai copiat nicio imagine.')
    }
  }

  const handleRemoveElement = useCallback(
    async (e, index) => {
      const copyElements = [...elements]
      if (index < copyElements.length) {
        copyElements.splice(index, 1)
        setElements(copyElements)
      }
    },
    [elements],
  )

  const handleMoveElementUp = useCallback(
    async (e, index) => {
      const copyElements = [...elements]
      if (index < copyElements.length && index > 0) {
        const aux = copyElements[index - 1]
        copyElements[index - 1] = copyElements[index]
        copyElements[index] = aux

        setElements(copyElements)
      }
    },
    [elements],
  )

  const handleMoveElementDown = useCallback(
    async (e, index) => {
      const copyElements = [...elements]
      if (index < copyElements.length - 1) {
        const aux = copyElements[index + 1]
        copyElements[index + 1] = copyElements[index]
        copyElements[index] = aux

        setElements(copyElements)
      }
    },
    [elements],
  )

  const handleChangeLoadId = event => {
    const value = event.target.value
    if (Number(value) <= 0 && value !== '') {
      return
    }
    setLoadId(value)
  }

  const handleReplaceChange = event => {
    const value = event.target.value
    if (Number(value) <= 0) {
      return
    }
    setReplace(value)
  }

  const handleChangeCorrectAnswer = useCallback(
    async index => {
      let newAnswer = String(answer)

      if (newAnswer === '-1') {
        newAnswer = String(index)
        setAnswer(newAnswer)
        return
      }

      if (newAnswer.indexOf(String(index)) === -1) {
        newAnswer += String(index)
      } else {
        const eliminatedCheckIndex = newAnswer.indexOf(String(index))
        newAnswer =
          newAnswer.substr(0, eliminatedCheckIndex) +
          newAnswer.substr(eliminatedCheckIndex + 1)
      }

      let response = orderAnswerOptionsDescending(newAnswer)
      if (isNaN(response)) {
        response = '-1'
      }

      setAnswer(response)
    },
    [answer],
  )

  const isChoiceInAnswer = useCallback(
    index => {
      return (
        String(answer).indexOf('-') === -1 &&
        String(answer).indexOf(String(index)) !== -1
      )
    },
    [answer],
  )

  const handleSymbolsSpacing = useCallback(() => {
    const copyElements = [...elements]
    copyElements.forEach(element => {
      element.content = insertSpaceAfterSymbols(element.content)
    })
    setElements(copyElements)

    const copyChoices = [...choices]
    copyChoices.forEach(element => {
      element.content = insertSpaceAfterSymbols(element.content)
    })
    setChoices(copyChoices)

    setHint(insertSpaceAfterSymbols(hint))
    setExplain(insertSpaceAfterSymbols(explain))
  }, [elements, choices, hint, explain])

  const loadIndexFromSource = useCallback((source, index) => {
    if (source !== undefined && index >= 0 && index < source.length) {
      const elements = source[index].filter(element => {
        return element.type.indexOf('choice') === -1
      })
      const choices = source[index].filter(element => {
        return element.type.indexOf('choice') !== -1
      })

      setElements(elements)
      setChoices(choices)
    }
  }, [])

  const loadNextGridFromSource = useCallback(() => {
    if (currentIndexGridFromSource < gridsFromSource.length - 1) {
      loadIndexFromSource(gridsFromSource, currentIndexGridFromSource + 1)
      setCurrentIndexGridFromSource(currentIndexGridFromSource + 1)
    }
  }, [gridsFromSource, currentIndexGridFromSource, loadIndexFromSource])

  const loadPrevGridFromSource = useCallback(() => {
    if (currentIndexGridFromSource > 0) {
      loadIndexFromSource(gridsFromSource, currentIndexGridFromSource - 1)
      setCurrentIndexGridFromSource(currentIndexGridFromSource - 1)
    }
  }, [gridsFromSource, currentIndexGridFromSource, loadIndexFromSource])

  const submitAndLoadNextFromSource = useCallback(async () => {
    if (
      gridsFromSource !== undefined &&
      currentIndexGridFromSource !== undefined &&
      currentIndexGridFromSource >= 0 &&
      currentIndexGridFromSource < gridsFromSource.length &&
      gridsFromSource[currentIndexGridFromSource] !== undefined
    ) {
      if (
        currentSubmitedFromSource.indexOf(currentIndexGridFromSource) === -1
      ) {
        const [json, answerText, tagsText] = getPayloadForSubmit()

        const payload = {
          json,
          faculty,
          tags: tagsText,
          answer: answerText,
          explain,
          source_id: selectedSource.length > 0 ? selectedSource[0].id : 'null',
          hint,
          deleted,
          materie_copiat:
            selectedSubject && selectedSubject.length > 0
              ? selectedSubject[0].name
              : null,
          multiple_choice: multipleChoice,
        }

        if (replace) {
          payload['replace_id'] = replace
        }

        const response = await GrileService.create(payload)
        if (Object.keys(response).includes('error')) {
          toast.warn(response.error)
        } else {
          if (replace) {
            toast.warn(`Ai înlocuit grila cu id: ${response.id}`)
          } else {
            toast.warn(`Ai creat grila cu id: ${response.id}`)
          }

          let copyCurrentSubmitedFromSource = [...currentSubmitedFromSource]
          copyCurrentSubmitedFromSource.push(currentIndexGridFromSource)
          setCurrentSubmitedFromSource(copyCurrentSubmitedFromSource)

          if (currentIndexGridFromSource < gridsFromSource.length - 1) {
            loadNextGridFromSource()
            setSelectedTags([])
            multiselectRef.current.resetSelectedValues()
          } else {
            toast.warn('Ai trimis toate grilele din acest document.')
            handleClear()
            setGridsFromSource(undefined)
          }
        }
      } else {
        toast.warn('Ai trimis deja grila curenta!')
      }
    }
  }, [
    selectedSource,
    selectedSubject,
    multipleChoice,
    replace,
    gridsFromSource,
    currentIndexGridFromSource,
    currentSubmitedFromSource,
    deleted,
    explain,
    faculty,
    getPayloadForSubmit,
    handleClear,
    hint,
    loadNextGridFromSource,
  ])

  const getGridsFromFile = useCallback(async () => {
    handleClear()

    if (copying) {
      toast.warn('Un fisier este deja in curs de copiere!')
      return
    }

    if (copySource === undefined) {
      toast.warn('Fisier incorect!')
      return
    }

    let content = undefined
    let type = undefined
    if (copySource.type === 'application/pdf') {
      /* file is PDF */
      type = 'text'

      try {
        content = await pdfToText(copySource)
        if (content === undefined || content === '') {
          toast.warn(
            'Nu s-a putut extrage textul din fisierul PDF. Verifica continutul acestuia!',
          )
          throw new Error('PDF extraction failed')
        }
      } catch {
        toast.warn(
          'Nu s-a putut extrage textul din fisierul PDF. Verifica continutul acestuia!',
        )
        return
      }
    } else if (copySource.type?.indexOf('image') !== -1) {
      type = 'image'

      /* file is image */
      content = await toBase64(copySource)
      setCopySource(content)
    } else {
      toast.warn('Tipul fisierului nu este pdf sau imagine. Verifica fisierul!')
      return
    }

    let jsonResponse = undefined
    try {
      setCopying(true)

      const response = await GrileService.copyFromSource({
        type: type,
        content: content,
        indexToStart:
          indexToStartFromSource !== 0 ? parseInt(indexToStartFromSource) : 0,
        nrGrids: nrGridsFromSource !== -1 ? parseInt(nrGridsFromSource) : -1,
      })

      jsonResponse = JSON.parse(response?.choices?.[0].message?.content)

      setCopying(false)
    } catch (e) {
      console.log(e)
      toast.warn(e)
      setCopySource(undefined)
      setCopying(false)
      return
    }

    setGridsFromSource(jsonResponse?.['data'])
    setCurrentIndexGridFromSource(0)

    loadIndexFromSource(jsonResponse?.['data'], 0)
  }, [
    copySource,
    indexToStartFromSource,
    nrGridsFromSource,
    copying,
    handleClear,
    loadIndexFromSource,
  ])

  const handleAddDollarSignToChoice = useCallback(
    index => {
      if (index >= 0 && index < choices.length) {
        let copyChoices = [...choices]
        copyChoices[index].content = '$' + copyChoices[index].content + '$'
        setChoices(copyChoices)
      }
    },
    [choices],
  )

  const handleAddDollarSignToAllChoices = useCallback(() => {
    let copyChoices = [...choices]
    for (let index = 0; index < choices.length; index++) {
      copyChoices[index].content = '$' + copyChoices[index].content + '$'
    }
    setChoices(copyChoices)
  }, [choices])

  return (
    <DashboardLayout>
      <div className="flex blg:ml-[110px] lg:ml-0 xl:ml-0 lg:flex-row flex-col 2xl:gap-20 xl:gap-10 blg:gap-8 lg:gap-5">
        <div
          className={`lg:w-[calc(50vw-40px)] blg:w-[calc(50vw-100px)] xl:w-[calc(50vw-110px)] w-full lg:h-fit `}
        >
          <div className="rounded-xl border border-brd-primary text-over-ternary-background p-5 bg-container-background">
            <div className="w-full">
              <div className="mt-[10px] flex gap-3">
                {userDetails?.isAdmin && (
                  <div className="flex flex-row">
                    <Button
                      className="bg-btn-primary h-10  text-white lg:font-bold text-lg py-1 lg:px-4 rounded disabled:bg-gray-600"
                      disabled={
                        isLoadComponentVisible() || generating || copying
                      }
                      onClick={async () => {
                        setUsingMode('load')
                      }}
                    >
                      Compune / Încarcă
                    </Button>

                    <Button
                      className="bg-btn-primary ml-2 h-10  text-white lg:font-bold text-lg py-1 lg:px-4 rounded disabled:bg-gray-600"
                      disabled={
                        isCopyComponentVisible() || generating || copying
                      }
                      onClick={async () => {
                        setUsingMode('copy')
                      }}
                    >
                      Copiază
                    </Button>

                    <Button
                      className="bg-btn-primary ml-2 h-10  text-white lg:font-bold text-lg py-1 lg:px-4 rounded disabled:bg-gray-600"
                      disabled={
                        isGenerateComponentVisible() || generating || copying
                      }
                      onClick={async () => {
                        setUsingMode('generate')
                      }}
                    >
                      Generează
                    </Button>
                  </div>
                )}
                <Button
                  className="bg-btn-primary h-10 text-white lg:font-bold text-lg py-1 lg:px-4 rounded disabled:bg-gray-600"
                  onClick={handleClear}
                  disabled={generating || copying}
                >
                  Golește
                </Button>
              </div>
              {isLoadComponentVisible() && (
                <div className="flex flex-col md:flex-row gap-3 mt-3">
                  <input
                    type="number"
                    id="loadId"
                    className="border bg-container-background text-sm text-over-ternary-background truncate border-brd-primary rounded-md p-2 h-10"
                    placeholder="Id grilă"
                    value={loadId}
                    onInput={handleChangeLoadId}
                  />
                  <div className="flex gap-3">
                    {loadId !== '' && (
                      <Button
                        className="bg-btn-primary  text-sm h-10 text-white lg:font-bold  py-1 px-4 rounded"
                        onClick={async () => {
                          handleLoadGrid(await GrileService.grilaWithId(loadId))
                        }}
                      >
                        Încarcă
                      </Button>
                    )}
                    {loadId !== '' && (
                      <Button
                        className="bg-btn-primary  h-10  ml-2 text-white text-sm lg:font-bold  py-1 px-4 rounded"
                        onClick={() => handleLoadPrev()}
                      >
                        Anterioara
                      </Button>
                    )}
                    {loadId !== '' && (
                      <Button
                        className="bg-btn-primary h-10 ml-2 text-white text-sm lg:font-bold  py-1 px-4 rounded"
                        onClick={() => handleLoadNext()}
                      >
                        Următoarea
                      </Button>
                    )}
                  </div>
                </div>
              )}

              <div>
                {isCopyComponentVisible() && (
                  <div>
                    <div className="flex flex-col mt-4">
                      <div className="mb-2">PDF (recomandat):</div>
                      <input
                        type="file"
                        accept="application/pdf,image*"
                        onChange={e => setCopySource(e.target.files[0])}
                        disabled={copying}
                      />
                    </div>

                    <div className="mt-5 mb-[10px]">
                      <div>Imagine: (dimensiuni mici, o singura grila)</div>
                      <img
                        className="mt-[10px] mb-[10px]"
                        src={copySource}
                        width="100px"
                      />
                      <div
                        className="mt-1 p-2 text-over-ternary-background text-gray-400 text-sm w-full border border-brd-primary min-h-16 rounded-lg"
                        onPaste={e => {
                          setCopySource(e.clipboardData.files[0])
                        }}
                      >
                        Paste Area (Ctrl + V image here)
                      </div>

                      <div className="mt-2">
                        <div>
                          <label htmlFor="nrGridsFromSource">
                            Numar de grile in document:
                          </label>
                          <input
                            type="text"
                            name="nrGridsFromSource"
                            className="border border-brd-primary text-sm bg-container-background text-over-ternary-background rounded-md p-2 ml-1 w-11"
                            src={nrGridsFromSource}
                            onChange={e => setNrGridsFromSource(e.target.value)}
                          />
                        </div>
                        <div className="mt-1">
                          <label htmlFor="indexToStartFromSource">
                            Incepe de la grila numarul:
                          </label>
                          <input
                            type="text"
                            name="indexToStartFromSource"
                            className="border border-brd-primary text-sm bg-container-background text-over-ternary-background rounded-md p-2 ml-1 w-11"
                            src={indexToStartFromSource}
                            onChange={e =>
                              setIndexToStartFromSource(e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <Button
                        onClick={getGridsFromFile}
                        className="bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 mt-2 align-center"
                        disabled={copying}
                      >
                        Start copiere
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              {isGenerateComponentVisible() && (
                <div className="mt-[10px] ">
                  <div className="text-base lg:text-xl mt-4">
                    Generează din capitolele: (lasă gol pentru toate)
                  </div>
                  <Multiselect
                    style={{
                      selectContainer: {
                        backgroundColor: 'red',
                      },
                      optionContainer: {
                        backgroundColor: 'rgb(var(--secondary-background))',
                        color: 'rgb(var(--over-secondary-background))',
                      },

                      searchBox: {
                        border: 'none',
                      },
                      chips: {
                        backgroundColor: 'rgb(var(--ternary))',
                      },
                    }}
                    className="border rounded border-brd-primary mt-2 text-sm bg-container-background text-over-ternary-background"
                    options={allTags}
                    selectedValues={selectedTagsForGenerate}
                    onSelect={(selectedList, selectedItem) =>
                      setSelectedTagsForGenerate(current => [
                        ...current,
                        selectedItem,
                      ])
                    }
                    onRemove={(selectedList, removedItem) =>
                      setSelectedTagsForGenerate(current =>
                        current.filter(item => item !== removedItem),
                      )
                    }
                    displayValue="name"
                    placeholder="Tags"
                  />
                  <Button
                    className="bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 mt-2"
                    disabled={generating}
                    onClick={handleGenerateGrila}
                  >
                    Start generare
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="rounded-xl border border-brd-primary text-over-ternary-background p-5 bg-container-background mt-4">
            <div>
              <div>
                {generating || copying ? (
                  <Spinner />
                ) : (
                  <div className="w-100">
                    {isCopyComponentVisible() &&
                      gridsFromSource !== undefined &&
                      currentIndexGridFromSource !== undefined &&
                      gridsFromSource.length > 1 && (
                        <div className="flex flex-row pb-4 border-b-[1px] border-black">
                          <Button
                            className="bg-btn-primary  text-white text-sm h-10 mr-3 lg:font-bold px-1 lg:py-1 lg:px-3 rounded disabled:bg-gray-600"
                            disabled={currentIndexGridFromSource === 0}
                            onClick={() => loadPrevGridFromSource()}
                          >
                            Prev
                          </Button>

                          <div className="content-center">
                            {' '}
                            Grila {currentIndexGridFromSource + 1}/
                            {gridsFromSource?.length}{' '}
                            {currentSubmitedFromSource.indexOf(
                              currentIndexGridFromSource,
                            ) !== -1 && '- Trimisa'}
                          </div>

                          <Button
                            className="bg-btn-primary  text-white text-sm h-10 ml-3 lg:font-bold px-1 lg:py-1 lg:px-3 rounded disabled:bg-gray-600"
                            disabled={
                              gridsFromSource !== undefined &&
                              currentIndexGridFromSource ===
                                gridsFromSource.length - 1
                            }
                            onClick={() => loadNextGridFromSource()}
                          >
                            Next
                          </Button>
                        </div>
                      )}

                    <div className="mt-4 lg:text-xl">Cerință</div>
                    {elements.map((element, index) => {
                      return (
                        <div key={`element-${index}`} className="mt-[25px]">
                          <div className="flex">
                            <div className="flex">
                              {elements.length > 1 && (
                                <span className="ml-2">
                                  <Button
                                    className="bg-btn-primary text-white text-sm lg:font-bold lg:text-l px-[9px] py-[3px] rounded-b-lg"
                                    disabled={index === 0}
                                    onClick={e => {
                                      handleMoveElementUp(e, index)
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faArrowUp} />
                                  </Button>
                                  <Button
                                    className="bg-btn-primary mt-[2px] text-white text-sm lg:font-bold lg:text-m px-[9px] py-[3px] rounded-t-lg"
                                    disabled={index === elements.length - 1}
                                    onClick={e => {
                                      handleMoveElementDown(e, index)
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faArrowDown} />
                                  </Button>
                                </span>
                              )}

                              <span className="text-sm lg:text-xl ml-3 capitalize self-center">
                                {index + 1}. Celulă {element.type}
                              </span>
                            </div>
                            {element.type !== 'image' && (
                              <>
                                <Button
                                  className="bg-btn-primary ml-4 h-10 w-16 text-sm text-white lg:font-bold  px-1 py-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                                  disabled={element.type === 'text'}
                                  onClick={async e =>
                                    handleChangeBoxType(e, 'text', index)
                                  }
                                >
                                  Text
                                </Button>
                                <Button
                                  className="bg-btn-primary ml-2 h-10 w-16 text-white text-sm lg:font-bold  px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                                  disabled={element.type === 'code'}
                                  onClick={async e =>
                                    handleChangeBoxType(e, 'code', index)
                                  }
                                >
                                  Cod
                                </Button>
                                <Button
                                  className="bg-btn-primary ml-2 h-10 w-16 text-sm text-white lg:font-bold  px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                                  disabled={element.type === 'matrix'}
                                  onClick={async e =>
                                    handleChangeBoxType(e, 'matrix', index)
                                  }
                                >
                                  Matrice
                                </Button>
                              </>
                            )}
                            <Button
                              className="bg-btn-primary ml-[auto] h-10 w-16 text-white text-sm lg:font-bold px-1 lg:py-1 lg:px-2"
                              onClick={async e => handleRemoveElement(e, index)}
                            >
                              Remove
                            </Button>
                          </div>
                          {element && element.type === 'text' && (
                            <div className="mt-[5px] mb-[10px]">
                              <textarea
                                className="textArea border border-brd-primary text-sm bg-container-background text-over-ternary-background rounded-md p-2"
                                id={`element-${index}`}
                                placeholder="Text"
                                onPaste={e => {
                                  handlePaste(e, index)
                                }}
                                onChange={e => {
                                  handleChangeTextarea(e, index)
                                }}
                                value={element.content}
                              />
                            </div>
                          )}
                          {element && element.type === 'code' && (
                            <div className="mt-[5px] mb-[10px]">
                              <textarea
                                readOnly={indenting}
                                className="textArea border text-sm border-brd-primary bg-container-background text-over-ternary-background rounded-md p-2 "
                                id={`element-${index}`}
                                placeholder="Code"
                                onPaste={() => {
                                  handleCodePaste(index)
                                }}
                                onChange={e => {
                                  handleChangeTextarea(e, index)
                                }}
                                value={element.content}
                              />
                              <div className="flex ">
                                <Button
                                  disabled={indenting}
                                  onClick={() => {
                                    handleIndentCode(index)
                                  }}
                                  className="bg-btn-primary text-sm w-16 h-10 text-white lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                                >
                                  Indent
                                </Button>
                                <Button
                                  disabled={indenting}
                                  onClick={() => {
                                    handleIndentPseudocode(index)
                                  }}
                                  className="bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 ml-2"
                                >
                                  Indent pseudocod
                                </Button>
                              </div>
                            </div>
                          )}
                          {element && element.type === 'matrix' && (
                            <div className="mt-[5px] mb-[10px]">
                              <textarea
                                className="textArea border border-brd-primary bg-container-background text-over-ternary-background rounded-md p-2 "
                                id={`element-${index}`}
                                placeholder="Matrix"
                                onChange={e => {
                                  handleChangeTextarea(e, index)
                                }}
                                value={element.content}
                              />
                            </div>
                          )}
                          {element && element.type === 'image' && (
                            <div className="mt-[5px] mb-[10px]">
                              {element.content &&
                                element.content.length > 0 && (
                                  <img
                                    className="mt-[10px] mb-[10px]"
                                    src={element.content}
                                  />
                                )}
                              <FileBase64
                                onDone={e => {
                                  handleLoadImage(e, index)
                                }}
                              />
                              <div
                                onPaste={e => {
                                  handlePasteImage(e, index)
                                }}
                              >
                                <div className="mt-1 p-2 text-over-ternary-background text-gray-400 text-sm w-full border border-brd-primary min-h-16 rounded">
                                  Paste Area (Ctrl + V image here)
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    })}
                    <div className="flex gap-3 mt-2">
                      <Button
                        className="bg-btn-primary w-16 text-white lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 "
                        onClick={() => handleAddElement('text')}
                      >
                        Text
                      </Button>
                      <Button
                        className="bg-btn-primary w-16 ml-2 max-w-[100px]  text-white lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2"
                        onClick={() => handleAddElement('code')}
                      >
                        Cod
                      </Button>
                      <Button
                        className="bg-btn-primary w-16 ml-2 text-white  lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                        onClick={() => handleAddElement('matrix')}
                      >
                        Matrice
                      </Button>
                      <Button
                        className="bg-btn-primary w-16 ml-2  text-white lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                        onClick={() => handleAddElement('image')}
                      >
                        Imagine
                      </Button>
                    </div>
                    <div className="mt-7 text-xl">Variante de răspuns</div>
                    <div className="flex gap-3 mt-2">
                      <Button
                        onClick={e => handleChangeChoicesType(e, 'text')}
                        disabled={choicesType === 'text'}
                        className="bg-btn-primary w-16 text-white lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                      >
                        Text
                      </Button>
                      <Button
                        onClick={e => handleChangeChoicesType(e, 'code')}
                        disabled={choicesType === 'code'}
                        className="bg-btn-primary ml-2 w-16 text-white  lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                      >
                        Cod
                      </Button>
                      <Button
                        onClick={e => handleChangeChoicesType(e, 'matrix')}
                        disabled={choicesType === 'matrix'}
                        className="bg-btn-primary  w-16 ml-2 text-white  lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                      >
                        Matrice
                      </Button>
                      <Button
                        onClick={handleAddDollarSignToAllChoices}
                        className="bg-btn-primary  w-8 ml-2 text-white  lg:font-bold text-lg h-10 px-1 lg:py-1 lg:px-2 disabled:bg-gray-600"
                      >
                        $
                      </Button>
                    </div>
                  </div>
                )}
                {!generating && !copying && (
                  <div className="mt-7">
                    {choices.map((element, index) => {
                      return (
                        <>
                          <div key={`choice-${index}`} className="flex mt-2">
                            <div className="flex flex-col justify-between">
                              <input
                                className="w-5 h-5 filter-checkbox filtered-checkbox-tag"
                                type="checkbox"
                                id="choice-checkbox"
                                name="choice-checkbox"
                                checked={isChoiceInAnswer(index)}
                                onChange={() =>
                                  handleChangeCorrectAnswer(index)
                                }
                              />
                              <Button
                                className="bg-btn-primary w-6 h-6 text-white  lg:font-bold text-lg  px-1 py-1 mb-1 roundedrounded"
                                onClick={() =>
                                  handleAddDollarSignToChoice(index)
                                }
                              >
                                $
                              </Button>
                            </div>
                            <textarea
                              readOnly={indenting}
                              className={`choiceArea border w-full border-brd-primary bg-container-background text-sm text-over-ternary-background rounded-md p-2 ml-1 ${
                                isChoiceInAnswer(index) && `border-[#72c072]`
                              }`}
                              id={`choice-${choicesType}-${index}`}
                              placeholder={`Varianta ${choicesType}`}
                              onPaste={e => {
                                handleChoicePaste(e, index)
                              }}
                              value={element.content}
                              onChange={e => {
                                handleChangeChoices(e, index)
                              }}
                            />

                            {choicesType === 'code' && (
                              <div className="flex">
                                <Button
                                  className="bg-btn-primary ml-2 text-white lg:font-bold text-sm h-10 w-16 px-1 lg:py-1 lg:px-2"
                                  disabled={indenting}
                                  onClick={() => {
                                    handleIndentChoiceCode(index)
                                  }}
                                >
                                  Indent
                                </Button>
                                <Button
                                  disabled={indenting}
                                  onClick={() => {
                                    handleIndentChoicePseudocode(index)
                                  }}
                                  className="bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 ml-2"
                                >
                                  Indent pseudocod
                                </Button>
                              </div>
                            )}
                          </div>
                          {element.explainContent === undefined ? (
                            <Button
                              disabled={indenting}
                              onClick={() => {
                                handleAddChoiceExplain(index)
                              }}
                              className="mt-2 bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 ml-2"
                            >
                              Adaugă explicație la variantă
                            </Button>
                          ) : (
                            <div className="flex">
                              <textarea
                                readOnly={indenting}
                                className={`choiceArea border w-full border-brd-primary bg-container-background text-sm text-over-ternary-background rounded-md p-2 ml-1 mt-2`}
                                id={`explain-choice-${choicesType}-${index}`}
                                placeholder={`Explicație variantă ${choicesType}`}
                                value={element.explainContent}
                                onChange={e => {
                                  handleSetChoiceExplain(e, index)
                                }}
                              />
                              <Button
                                disabled={indenting}
                                onClick={() => {
                                  handleRemoveChoiceExplain(index)
                                }}
                                className="mt-2 bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 ml-2"
                              >
                                Șterge
                              </Button>
                            </div>
                          )}
                        </>
                      )
                    })}
                    <Button
                      onClick={handleAddChoice}
                      className="bg-btn-primary mt-2 text-white text-lg h-10 lg:font-bold"
                    >
                      Adaugă variantă
                    </Button>
                    <div className="mt-7 flex">
                      <div className="text-base lg:text-xl pr-2">
                        Răspuns multiplu:
                      </div>
                      <input
                        className="ml-1 w-5 h-5 bg-container-background text-over-ternary-background border border-brd-primary"
                        id="multipleChoice"
                        type="checkbox"
                        checked={multipleChoice}
                        onChange={handleChangeMultipleChoice}
                      />
                    </div>
                    <div className="flex mt-2 gap-3">
                      <div className="text-xl capitalize self-center ">
                        Răspuns:
                      </div>
                      <input
                        className="border bg-container-background text-over-ternary-background border-brd-primary rounded-md text-sm p-2 ml-1 w-[100px] h-10"
                        id="answer"
                        placeholder="Răspuns"
                        value={answer}
                        onChange={handleAnswerChange}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="lg:text-xl capitalize">Indiciu:</div>
                      <textarea
                        className="hintArea border mt-2 border-brd-primary  text-sm bg-container-background text-over-ternary-background rounded-md p-2"
                        id="hint"
                        placeholder="Indiciu"
                        value={hint ?? ''}
                        onChange={handleHintChange}
                      />
                    </div>
                    <div className="mt-3">
                      <div className="text-base lg:text-xl">Explicație:</div>
                      <textarea
                        className="explainArea border text-sm mt-2 border-brd-primary bg-container-background text-over-ternary-background rounded-md p-2"
                        id="explain"
                        placeholder="Explicație"
                        value={explain ?? ''}
                        onChange={handleExplainChange}
                      />
                    </div>
                    <Button
                      className="bg-btn-primary  text-white text-sm h-10  lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                      onClick={handleLoadHintAndExplainFromStorage}
                    >
                      {' '}
                      Încarcă ultimul text{' '}
                    </Button>
                    {/* Start admin only section */}
                    {userDetails?.isAdmin && (
                      <>
                        <div className="flex flex-col mt-2">
                          <div className="mt-[10px] flex gap-3">
                            <div className="text-base lg:text-xl capitalize self-center">
                              Facultate:
                            </div>
                            <Multiselect
                              style={{
                                selectContainer: {
                                  backgroundColor: 'red',
                                },
                                optionContainer: {
                                  backgroundColor:
                                    'rgb(var(--secondary-background))',
                                  color:
                                    'rgb(var(--over-secondary-background))',
                                },

                                searchBox: {
                                  border: 'none',
                                },
                                chips: {
                                  backgroundColor: 'rgb(var(--ternary))',
                                },
                              }}
                              className="border rounded border-brd-primary text-sm bg-container-background text-over-ternary-background"
                              options={allFaculties}
                              selectedValues={selectedFaculty}
                              onSelect={(selectedList, selectedItem) => {
                                setSelectedFaculty([selectedItem])
                                setSelectedSource([])
                              }}
                              onRemove={() => {
                                setSelectedSource([])
                                setSelectedFaculty([])
                              }}
                              closeOnSelect={true}
                              selectionLimit={2}
                              displayValue="name"
                              placeholder="Facultate"
                            />
                          </div>
                          <div className="mt-[10px] flex gap-3">
                            <div className="text-base lg:text-xl capitalize self-center">
                              Sursă:
                            </div>
                            <Multiselect
                              style={{
                                selectContainer: {
                                  backgroundColor: 'red',
                                },
                                optionContainer: {
                                  backgroundColor:
                                    'rgb(var(--secondary-background))',
                                  color:
                                    'rgb(var(--over-secondary-background))',
                                },

                                searchBox: {
                                  border: 'none',
                                },
                                chips: {
                                  backgroundColor: 'rgb(var(--ternary))',
                                },
                              }}
                              className="border rounded border-brd-primary text-sm bg-container-background text-over-ternary-background"
                              options={allSources.filter(
                                source =>
                                  selectedFaculty.length === 0 ||
                                  selectedFaculty[0].id === source.faculty_id,
                              )}
                              selectedValues={selectedSource}
                              onSelect={(selectedList, selectedItem) => {
                                selectSource(
                                  selectedItem.id,
                                  allSources,
                                  allFaculties,
                                )
                              }}
                              closeOnSelect={true}
                              selectionLimit={2}
                              displayValue="name"
                              placeholder="Sursă"
                            />
                          </div>
                          <div className="mt-[10px] mb-[10px] flex gap-3">
                            <div className="text-base lg:text-xl capitalize self-center mr-1 flex mt-[4px]">
                              Materie:
                            </div>
                            <Multiselect
                              style={{
                                selectContainer: {
                                  backgroundColor: 'red',
                                },
                                optionContainer: {
                                  backgroundColor:
                                    'rgb(var(--secondary-background))',
                                  color:
                                    'rgb(var(--over-secondary-background))',
                                },

                                searchBox: {
                                  border: 'none',
                                },
                                chips: {
                                  backgroundColor: 'rgb(var(--ternary))',
                                },
                              }}
                              className="border rounded border-brd-primary text-sm bg-container-background text-over-ternary-background"
                              options={selectSubjectOptions}
                              selectedValues={selectedSubject}
                              onSelect={(selectedList, selectedItem) => {
                                setSelectedSubject([selectedItem])
                                handleSetTagsForSubject(selectedItem.name)
                                setSelectedTags([])
                              }}
                              onRemove={() => {
                                setCurrentSubjectTags([])
                              }}
                              closeOnSelect={true}
                              selectionLimit={2}
                              displayValue="name"
                              placeholder="Materie"
                            />
                          </div>
                          <div className="mt-[10px] flex gap-3">
                            <div className="text-base lg:text-xl capitalize self-center mr-1">
                              Capitol:
                            </div>
                            <Multiselect
                              style={{
                                selectContainer: {
                                  backgroundColor: 'red',
                                },
                                optionContainer: {
                                  backgroundColor:
                                    'rgb(var(--secondary-background))',
                                  color:
                                    'rgb(var(--over-secondary-background))',
                                },

                                searchBox: {
                                  border: 'none',
                                },
                                chips: {
                                  backgroundColor: 'rgb(var(--ternary))',
                                },
                              }}
                              className="border rounded border-brd-primary text-sm bg-container-background text-over-ternary-background"
                              ref={multiselectRef}
                              options={currentSubjectTags}
                              selectedValues={selectedTags}
                              onSelect={(selectedList, selectedItem) =>
                                setSelectedTags(current => [
                                  ...current,
                                  selectedItem,
                                ])
                              }
                              onRemove={(selectedList, removedItem) =>
                                setSelectedTags(current =>
                                  current.filter(item => item !== removedItem),
                                )
                              }
                              displayValue="name"
                              placeholder="Tags"
                            />

                            <div className="flex mt-[10px]">
                              <div className="text-base lg:text-xl pr-2">
                                Exclude pagini:
                              </div>
                              <input
                                className="ml-2 bg-container-background text-over-ternary-background border border-brd-primary"
                                id="excludePages"
                                type="checkbox"
                                checked={excludePages}
                                onChange={e => {
                                  setExcludePages(current => !current)
                                  localStorage.setItem(
                                    'excludePages',
                                    e.target.checked,
                                  )
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mt-[10px] flex">
                          <div className="text-base lg:text-xl pr-2">
                            Deleted:
                          </div>
                          <input
                            className="ml-1 bg-container-background text-over-ternary-background border border-brd-primary"
                            id="deleted"
                            type="checkbox"
                            checked={deleted}
                            onChange={() => setDeleted(current => !current)}
                          />
                        </div>
                      </>
                    )}
                    {/* End admin only section */}
                    <div className="flex mt-[10px]">
                      <div className="text-base lg:text-xl capitalize self-center">
                        Înlocuire:
                      </div>
                      <input
                        className="border border-brd-primary text-sm bg-container-background text-over-ternary-background rounded-md p-2 ml-1 w-[100px] h-[30px] self-center"
                        type="number"
                        id="replace"
                        placeholder="Id"
                        value={replace}
                        onInput={handleReplaceChange}
                      />{' '}
                      <div className="text-sm self-center ml-1">
                        (Scrie aici id-ul grilei pe care vrei să o înlocuiești
                        sau lasă liber pt a crea o grila nouă)
                      </div>
                    </div>
                    {userDetails?.isAdmin && (
                      <div className="flex mt-[10px]">
                        <div className="text-base lg:text-xl self-center">
                          Ultima actualizare:{' '}
                          {updatedTimestamp !== ''
                            ? getFullDateHourString(
                                new Date(updatedTimestamp * 1000),
                              )
                            : ''}
                        </div>
                      </div>
                    )}
                    {userDetails?.isAdmin && (
                      <div className="flex mt-[10px]">
                        <div className="text-base lg:text-xl self-center">
                          Actualizat de: {creatorEmail}
                        </div>
                      </div>
                    )}
                    <div className="flex mt-[20px]">
                      {isCopyComponentVisible() ? (
                        <div className="flex flex-row">
                          <Button
                            className="bg-btn-primary  text-white text-sm h-10  lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                            disabled={
                              currentSubmitedFromSource.indexOf(
                                currentIndexGridFromSource,
                              ) !== -1
                            }
                            onClick={submitAndLoadNextFromSource}
                          >
                            Submit & next
                          </Button>
                          <Button
                            className="bg-btn-primary  text-white text-sm h-10 ml-2 lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                            disabled={currentIndexGridFromSource === 0}
                            onClick={loadNextGridFromSource}
                          >
                            Prev
                          </Button>
                          <Button
                            className="bg-btn-primary  text-white text-sm h-10 ml-2 lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                            disabled={
                              gridsFromSource !== undefined &&
                              currentIndexGridFromSource ===
                                gridsFromSource.length - 1
                            }
                            onClick={loadPrevGridFromSource}
                          >
                            Next
                          </Button>
                        </div>
                      ) : (
                        <Button
                          className="bg-btn-primary  text-white text-sm h-10  lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                          onClick={handleSubmit}
                        >
                          Creează
                        </Button>
                      )}
                      <Button
                        className="bg-btn-primary ml-2 h-10 text-white text-sm lg:font-bold px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
                        onClick={() => handleSymbolsSpacing()}
                      >
                        Spațiază simboluri
                      </Button>
                    </div>
                    {remainingElements.length > 0 &&
                      isGenerateComponentVisible() && (
                        <div style={{ marginTop: '50px' }}>
                          Text generat
                          <textarea
                            className="textArea border mt-2 text-sm border-brd-primary bg-container-background text-over-ternary-background rounded-md p-2"
                            placeholder="Text"
                            onChange={e => {
                              setRemainingElements(e.target.value)
                            }}
                            value={remainingElements}
                          />
                          <Button onClick={handleRegenerateGrila}>
                            Regenerate
                          </Button>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <AddPageSection books={books} />
          <UploadSection books={books} />
        </div>
        <div>
          <div>
            <div className="lg:fixed">
              <Grid
                height={height}
                setHeight={setHeight}
                createGrid
                widthClass={`lg:w-[calc(50vw-40px)] blg:w-[calc(50vw-100px)] xl:w-[calc(50vw-110px)] w-full max-sm:mt-4`}
                currentGrila={elements.concat(choices)}
                currentGridId={loadId}
                answer={{ correct_answer: answer, solvingTimePercent: '0%' }}
                explanationPreview={explain}
                hintPreview={hint}
                gridTags={selectedTags.map(element => {
                  return element.id
                })}
                allTags={allTags.sort((a, b) => {
                  return a.id - b.id
                })}
                difficulty={
                  elements.length > 0 ? (
                    <span style={{ color: '#e9b654' }}>Medie</span>
                  ) : undefined
                }
                gridChapters="operatori"
                started={true}
                justStarted={false}
                endTrial={false}
                isMultipleChoice={multipleChoice}
                isGettingNextGrid={false}
                isLoading={false}
                isSubmitted={true}
                setCheckbox={() => {}}
                hasSubscription={true}
                handleGetRemainingTimeString={() => {}}
                handleUserGetHint={() => {}}
                handleTagsCheckboxChange={() => {}}
                handleUpdateGrid={() => {}}
                updateFiltersInStorage={() => {}}
                noMargin={true}
                explainAnswers={explainAnswersPreview}
                books={books}
                book={getBookById()}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
export default GrilaCreator
